  import api from '../../api/api.js'
  import request from '../../api/request.js'
  import { useStorage } from "@vueuse/core";

export default {
  state: ()=>{
    return {
      author:null,
      infor:null
    }
  },
  mutations: {
    initUser (state,infor) {
      state.infor=infor
    },
    initAuthor (state,author) {
      state.author=author
    },
  },
  actions: {
    async getAuthor ({ commit,state }) {
      if(state.author==null){
        const res = await new request(api.m().sysUser_getSessionUser,{}).modepost()
        if(res.status == 200){
          let listAuths = res.data.data.listAuths;
          let authOBbj = {}
          for(let i=0;i<listAuths.length;i++){
            authOBbj["auth_"+listAuths[i]]=true
          }
          commit('initAuthor',authOBbj)
          commit('initUser',res.data.data)
          //更新下本地缓存的数据
          localStorage.setItem("userName", res.data.data.username); 
          localStorage.setItem("loginName", res.data.data.name); 
          localStorage.setItem("userType", res.data.data.userType); 
          localStorage.setItem("listAuths", JSON.stringify(res.data.data.listAuths)); 
          localStorage.setItem("defaultProduct", res.data.data.defaultProduct); 
          localStorage.setItem("lastLoginDate", res.data.data.lastLoginDate || '');
        }
        return state.author
      }else{
        return state.author
      }
    },
  },
  getters: {

  }
};


